import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { ThingsToDoLocationData } from '../types';

interface FetchCachedEventIdsParams {
    queryKeyPrefix: string;
    locationData: ThingsToDoLocationData;
    tabs: number[];
}

const useFetchCachedEventIds = (props: FetchCachedEventIdsParams) => {
    const { queryKeyPrefix, locationData, tabs } = props;
    const [eventIds, setEventIds] = useState<string[]>([]);
    const queryClient = useQueryClient();

    useEffect(() => {
        const fetchCachedEventIds = async () => {
            const allEventIds: Set<string> = new Set();

            for (const tab of tabs) {
                const cachedTabData: any = queryClient.getQueryData([
                    queryKeyPrefix,
                    locationData,
                    tab,
                ]);

                if (cachedTabData && cachedTabData.events) {
                    cachedTabData.events.results.forEach((event: any) => {
                        allEventIds.add(event.id);
                    });
                }
            }
            const newEventIds = Array.from(allEventIds);
            if (!arraysEqual(eventIds, newEventIds)) {
                setEventIds(newEventIds);
            }
        };

        fetchCachedEventIds();
    }, [queryKeyPrefix, locationData, queryClient, tabs, eventIds]);

    return eventIds;
};
export default useFetchCachedEventIds;

const arraysEqual = (arr1: any[], arr2: any[]) => {
    return JSON.stringify(arr1) === JSON.stringify(arr2);
};
